import { ROUTES } from 'src/constants';
import { IRootStore } from '@src/models';
import { isCompanyDomain } from '@src/helpers';

type HandlerArgs = {
  action: {
    tree: IRootStore;
  };
};

const basicFlows = {
  [ROUTES.home]: {
    exact: false,
    call: async ({ action }: HandlerArgs) => {
      const fetchUserRequest = action.tree.authStore.FRA_authorize();
      if (isCompanyDomain()) {
        action.tree.companyStore.FRA_getCompany();
        action.tree.companyStore.FRA_getCompanyAccessPolicies();
        await fetchUserRequest;
        if (action.tree.userStore.isEmployer) {
          action.tree.companyStore.FRA_getCompanyActiveJobsCount();
          action.tree.companyStore.FRA_getCompanyInterests();
        }
      }
    }
  }
};

export default basicFlows;
